import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { STORE_NAMES } from '../../constants/store.constants';
import { ERROR_STATUS_ROUTE_MAP } from '../../constants/error.constants';
import zoomAppClient from '../../helper/zoomAppClient';
import { APP_RUNNING_CONTEXT_IN_MEETING } from '../../constants/zoomApp.constants';

const ErrorPageDecisionMaker = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    initializationErrorStatus,
    appUnavailableStatus,
    integratedFlowUnavailableStatus,
    nonIntegratedFlowUnavailableStatus,
    directoryFlowUnavailableStatus
  } = useSelector(state => state?.[STORE_NAMES.APP]);

  const getErrorNavigationRoutePath = statusValuesMap => {
    let routePath = null;
    for (const errorType in statusValuesMap) {
      if (!routePath) {
        routePath = statusValuesMap[errorType] === true ? ERROR_STATUS_ROUTE_MAP[errorType] : null;
      }
    }
    return routePath;
  };

  useEffect(() => {
    const handleRunningContextChange = runningContext => {
      if (runningContext === APP_RUNNING_CONTEXT_IN_MEETING) {
        navigate(`/home${location.search}${location.hash}`, { replace: true });
      }
    };
    return zoomAppClient.subscribeToRunningContextChange(handleRunningContextChange);
  }, [location.hash, location.pathname, location.search, navigate]);

  useEffect(() => {
    const statusValuesMap = {
      initializationErrorStatus,
      appUnavailableStatus,
      integratedFlowUnavailableStatus,
      nonIntegratedFlowUnavailableStatus,
      directoryFlowUnavailableStatus
    };
    const routePath = getErrorNavigationRoutePath(statusValuesMap);
    if (routePath) {
      navigate(routePath);
    }
  }, [
    initializationErrorStatus,
    appUnavailableStatus,
    integratedFlowUnavailableStatus,
    nonIntegratedFlowUnavailableStatus,
    directoryFlowUnavailableStatus
  ]);

  return <Outlet />;
};

export default ErrorPageDecisionMaker;
